// @ts-nocheck

import { createContext, useContext } from 'react';

type BoomViewContextProps = {
  height: number;
  width: number;
  fixScroll: boolean;
  setFixScroll: (value: boolean) => void;
};

export const BoomViewContext = createContext<BoomViewContextProps>({
  height: 0,
  width: 0,
  fixScroll: false,
  setFixScroll: () => {},
});

export const useBoomViewContext = () => useContext(BoomViewContext);
